
import type { CSSProperties } from 'react'

interface IconProps {
  name: string
  size?: 'sm' | 'md' | 'lg' | number
  className?: string
  style?: CSSProperties
}

const SIZE_MAP = { sm: 18, md: 20, lg: 24 }

export function Icon({ name, size = 'md', className = '', style }: IconProps) {
  const px = typeof size === 'number' ? size : SIZE_MAP[size]
  return (
    <span
      className={`mi ${className}`}
      style={{ fontSize: px, ...style }}
      aria-hidden
    >
      {name}
    </span>
  )
}
